// extracted by mini-css-extract-plugin
module.exports = {"card-collapsed":"CardBody_card-collapsed__1R82K"};